<template>
  <el-table-column
    prop="creator_user_name"
    sortable="custom"
    label="Létrehozta"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <div v-if="scope.row.creator_user_id && scope.row.creator_user">
        <strong>#{{ scope.row.creator_user_id }}</strong> {{ scope.row.creator_user.full_name }}
      </div>
      <div v-else>
        <div>{{ scope.row.creator_user_name }}</div>
        <el-tag
          size="mini"
          type="danger"
        >
          Törölt felhasználó
        </el-tag>
      </div>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'creator_user_name',
  };
</script>
